import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

import { ROUTE_NAMES } from '~/scopes/dashboard/constants'

const { DASHBOARD } = ROUTE_NAMES

// https://nuxt.com/docs/guide/directory-structure/middleware
export default defineNuxtRouteMiddleware((to) => {
  if (to.query.intercom_ticket_id && to.query.notification_link_uid) {
    if (to.name !== DASHBOARD.MY_ORDERS.SELF) {
      return navigateTo({
        name: DASHBOARD.MY_ORDERS.SELF,
        replace: true,
        params: {
          locale: to.params.locale,
        },
        query: {
          intercom_ticket_id: String(to.query.intercom_ticket_id),
        },
      })
    }
  }

  return true
})
